export default __webpack_public_path__ + "static/media/mute.ec0c7f26.svg";